import styled from 'styled-components';
import { Text } from '../text/index.js';
export const InputLoading = styled(Text).attrs({
    loading: 'x30',
    loadingColor: 'secondaryActive',
}) `
  width: 100%;
  display: flex;
`;
//# sourceMappingURL=input-loading.styles.js.map